<template>
    <div class="page-wrapper">
        <div class="container-fluid p-0">
            <div class="authentication-main">
                <div class="row">
                    <div class="col-md-12">
                        <div class="auth-innerright">
                            <div class="authentication-box">
                                <div class="text-center"><img alt="" src="@/assets/images/endless-logo.png"></div>
                                <div class="card mt-4">
                                    <div class="card-body">
                                        <div class="text-center">
                                            <h4>LOGIN</h4>
                                            <h6>Enter your Username and Password </h6>
                                        </div>
                                        <div v-if="errorMessage" class="alert alert-danger" role="alert">
                                            {{ errorMessage }}
                                        </div>
                                        <div v-if="attemptsLeft !== null && attemptsLeft > 0" class="alert alert-warning" role="alert">
                                            {{ attemptsLeft }} login attempt{{ attemptsLeft === 1 ? '' : 's' }} left before your account is locked for 24 hours.
                                        </div>
                                        <form class="theme-form" @submit.prevent="doLogin">
                                            <div class="form-group">
                                                <label class="col-form-label pt-0">Username</label>
                                                <input v-model="username" class="form-control" type="text"
                                                    placeholder="Username" autocomplete="username" required>
                                            </div>
                                            <div class="form-group">
                                                <label class="col-form-label">Password</label>
                                                <input v-model="password" :type="type" class="form-control"
                                                    name="login[password]" placeholder="*********"
                                                    autocomplete="current-password" required>
                                                <div class="show-hide"><span class="show" @click="showPassword"> </span>
                                                </div>
                                            </div>
                                            <div class=" form-row mt-3 ">
                                                <button class="btn btn-primary btn-block w-100" type="submit"
                                                    :disabled="loading">
                                                    <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                    {{ loading ? 'Signing in...' : 'Sign in' }}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { API_BASE } from '../config/api';

export default {
    data() {
        return {
            type: 'password',
            username: '',
            password: '',
            loading: false,
            errorMessage: '',
            attemptsLeft: null,
        }
    },

    methods: {
        showPassword() {
            this.type = this.type === 'password' ? 'text' : 'password';
        },
        async doLogin() {
            this.errorMessage = '';
            this.attemptsLeft = null;
            this.loading = true;
            try {
                const response = await fetch(`${API_BASE}/api/Auth/Login`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        username: this.username,
                        password: this.password,
                    }),
                });

                if (!response.ok) {
                    let error = await response.json().catch(() => null);
                    if (typeof error === 'string') {
                        try {
                            error = JSON.parse(error);
                        } catch {
                            error = null;
                        }
                    }
                    if (typeof error?.message === 'string') {
                        try {
                            const nestedError = JSON.parse(error.message);
                            if (nestedError && typeof nestedError === 'object') error = nestedError;
                        } catch { /* message is already plain text */ }
                    }
                    this.attemptsLeft = typeof error?.attemptsLeft === 'number' ? error.attemptsLeft : null;
                    const message = typeof error?.message === 'string'
                        ? error.message
                        : `Login failed (${response.status})`;
                    throw new Error(message);
                }

                const data = await response.json();
                const token = data.token || data.accessToken || data.jwt;

                if (!token) {
                    throw new Error('No token returned from server.');
                }

                localStorage.setItem('token', token);
                localStorage.setItem('user', this.username);
                this.$store.dispatch('auth/loadPermissions');

                const redirect = this.$route.query.redirect;
                const isSafeInternalPath = typeof redirect === 'string' && redirect.startsWith('/') && !redirect.startsWith('//');
                this.$router.replace(isSafeInternalPath ? redirect : '/');
            } catch (err) {
                this.errorMessage = err.message || 'Login failed. Please try again.';
            } finally {
                this.loading = false;
            }
        },
    }
}
</script>